module.exports = __webpack_public_path__ + "static/getinspired-hero2-alt-f32d4158ecbb82d0dfd6897014f8e27d.jpg";